import { memo } from 'react';
import { useUnmount, useUpdateEffect } from 'react-use';
import { useFormikContext } from 'formik';
import { useDebouncedCallback } from 'use-debounce';

export interface AutoSaveProps {
  readonly wait?: number;
  readonly maxWait?: number;
  readonly disabled?: boolean;
}

export const AutoSave = memo(({ wait = 5000, maxWait = 10000, disabled = false }: AutoSaveProps) => {
  const { values, submitForm } = useFormikContext();

  const debouncedSubmitForm = useDebouncedCallback(submitForm, wait, {
    maxWait,
  });

  useUpdateEffect(() => {
    if (disabled) {
      return;
    }

    debouncedSubmitForm();
  }, [values]);

  useUpdateEffect(() => {
    // Cancel, never unmount: unmounting would trigger `useUnmount`'s flush below and fire
    // exactly the save this flip exists to prevent.
    if (disabled) {
      debouncedSubmitForm.cancel();
    }
  }, [disabled]);

  useUnmount(() => {
    debouncedSubmitForm.flush();
  });

  return null;
});
